import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { ScreenReaderOnly } from "../screen-reader-only";
import { jsx as ___EmotionJSX } from "@emotion/core";

var formatSpan = function formatSpan(attributeValue, displayValue) {
  var additionalProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return ___EmotionJSX("span", _extends({
    "data-test-component": attributeValue
  }, additionalProps), displayValue);
};

export var formatBusinessTitle = function formatBusinessTitle(_ref) {
  var _ref$businessTitle = _ref.businessTitle,
      businessTitle = _ref$businessTitle === void 0 ? undefined : _ref$businessTitle,
      _ref$level = _ref.level,
      level = _ref$level === void 0 ? undefined : _ref$level;

  if (!businessTitle && !level) {
    return null;
  }

  var renderedBusinessTitle = businessTitle ? formatSpan('AvatarBusinessTitle', businessTitle) : undefined;
  var renderedLevel = level ? ___EmotionJSX(React.Fragment, null, formatSpan('AvatarLevel', "L".concat(level), {
    'aria-hidden': true
  }), ___EmotionJSX(ScreenReaderOnly, null, "Level ".concat(level))) : undefined;
  return ___EmotionJSX(React.Fragment, null, renderedBusinessTitle, !!renderedBusinessTitle && !!renderedLevel && ___EmotionJSX("span", {
    "aria-hidden": true
  }, ", "), renderedLevel);
};
export var formatDepartment = function formatDepartment(_ref2) {
  var _ref2$departmentName = _ref2.departmentName,
      departmentName = _ref2$departmentName === void 0 ? undefined : _ref2$departmentName,
      _ref2$departmentId = _ref2.departmentId,
      departmentId = _ref2$departmentId === void 0 ? undefined : _ref2$departmentId;

  if (!departmentName || !departmentName.length) {
    return null;
  }

  return ___EmotionJSX(React.Fragment, null, formatSpan('AvatarDepartmentName', departmentName), !!departmentId && !!departmentId.length && ___EmotionJSX(React.Fragment, null, " ", "(", formatSpan('AvatarDepartmentId', departmentId), ")"));
};
export var formatLocation = function formatLocation(_ref3) {
  var _ref3$city = _ref3.city,
      city = _ref3$city === void 0 ? undefined : _ref3$city,
      _ref3$country = _ref3.country,
      country = _ref3$country === void 0 ? undefined : _ref3$country;

  if (!!country && !!country.length && !!city) {
    return ___EmotionJSX(React.Fragment, null, formatSpan('AvatarCity', city), ___EmotionJSX("span", {
      "aria-hidden": true
    }, ", ", " "), formatSpan('AvatarCountry', country));
  }

  if (!!country && !!country.length) {
    return formatSpan('AvatarCountry', country);
  }

  if (!!city && !!city.length) {
    return formatSpan('AvatarCity', city);
  }

  return null;
};